import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import Vibrant from 'node-vibrant';
import contrast from 'color-contrast';
import convert from 'color-convert';

var prioritizeSwatches = function prioritizeSwatches(palette, priority) {
  return priority.map(function (swatchName) {
    return palette[swatchName];
  }).filter(function (swatch) {
    return !!swatch;
  });
};

var deprioratizeYellows = function deprioratizeYellows(swatches) {
  var range = [20, 80];
  var yellows = [];
  var nonYellows = [];
  swatches.forEach(function (swatch) {
    var hue = swatch.hsl[0] * 360;

    if (hue >= range[0] && hue <= range[1]) {
      yellows.push(swatch);
    } else {
      nonYellows.push(swatch);
    }
  });
  return [].concat(nonYellows, yellows);
};

var pickTopSwatch = function pickTopSwatch(swatches) {
  return swatches[0];
};

var getHex = function getHex(swatch) {
  return swatch.hex;
};

var ensureContrastRatio = function ensureContrastRatio(hex) {
  var AA = 4.5;
  var hsl = convert.hex.hsl(hex);

  while (contrast("#".concat(convert.hsl.hex(hsl)), '#FFFFFF') < AA && hsl[2] > 0) {
    hsl[2] -= 1;
  }

  return "#".concat(convert.hsl.hex(hsl));
};

var defaultSwatchPriority = ['Vibrant', 'DarkVibrant', 'LightVibrant', 'Muted', 'DarkMuted', 'LightMuted'];
var defaultConfig = {
  priority: defaultSwatchPriority,
  removeYellows: true,
  ensureContrast: true
};
export var extractColor = function extractColor(src) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultConfig;
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var config, removeYellows, ensureContrast, priority;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = Object.assign(Object.assign({}, defaultConfig), params);
            removeYellows = config.removeYellows, ensureContrast = config.ensureContrast;
            priority = config.priority || defaultConfig.priority;
            return _context.abrupt("return", Vibrant.from(src).getPalette().then(function (palette) {
              var prioritized = prioritizeSwatches(palette, priority);
              var deprioritizedYellows = [];

              if (removeYellows) {
                deprioritizedYellows = deprioratizeYellows(prioritized);
              }

              var prioritizedSwatches = deprioritizedYellows.length ? deprioritizedYellows : prioritized;
              var topSwatch = pickTopSwatch(prioritizedSwatches);
              var hex = getHex(topSwatch);

              if (ensureContrast) {
                var contrasted = ensureContrastRatio(hex);
                return contrasted;
              }

              return hex;
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};